"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncSubscriptionObjectsSchema = void 0;
exports.SyncSubscriptionObjectsSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        messageId: {
            type: 'string',
        },
        serviceContractId: {
            type: 'string',
        },
        subscriptionNumber: {
            type: 'string',
        },
        eventType: {
            type: 'string'
        }
    },
    required: [
        'subscriptionNumber',
        'serviceContractId'
    ],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3luYy1zdWJzY3JpcHRpb24tb2JqZWN0cy1zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZG9tcy9zY2hlbWFzL3N5bmMtc3Vic2NyaXB0aW9uLW9iamVjdHMtc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsT0FBTyxFQUFFLHlDQUF5QztJQUNsRCxVQUFVLEVBQUU7UUFDVixTQUFTLEVBQUU7WUFDVCxJQUFJLEVBQUUsUUFBUTtTQUNmO1FBQ0QsaUJBQWlCLEVBQUU7WUFDakIsSUFBSSxFQUFFLFFBQVE7U0FDZjtRQUNELGtCQUFrQixFQUFFO1lBQ2xCLElBQUksRUFBRSxRQUFRO1NBQ2Y7UUFDRCxTQUFTLEVBQUU7WUFDVCxJQUFJLEVBQUUsUUFBUTtTQUNmO0tBQ0Y7SUFDRCxRQUFRLEVBQUU7UUFDUixvQkFBb0I7UUFDcEIsbUJBQW1CO0tBQ3BCO0lBQ0QsSUFBSSxFQUFFLFFBQVE7Q0FDZixDQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IFN5bmNTdWJzY3JpcHRpb25PYmplY3RzU2NoZW1hID0ge1xuICAkc2NoZW1hOiAnaHR0cDovL2pzb24tc2NoZW1hLm9yZy9kcmFmdC0wNy9zY2hlbWEjJyxcbiAgcHJvcGVydGllczoge1xuICAgIG1lc3NhZ2VJZDoge1xuICAgICAgdHlwZTogJ3N0cmluZycsXG4gICAgfSxcbiAgICBzZXJ2aWNlQ29udHJhY3RJZDoge1xuICAgICAgdHlwZTogJ3N0cmluZycsXG4gICAgfSxcbiAgICBzdWJzY3JpcHRpb25OdW1iZXI6IHtcbiAgICAgIHR5cGU6ICdzdHJpbmcnLFxuICAgIH0sXG4gICAgZXZlbnRUeXBlOiB7XG4gICAgICB0eXBlOiAnc3RyaW5nJ1xuICAgIH1cbiAgfSxcbiAgcmVxdWlyZWQ6IFtcbiAgICAnc3Vic2NyaXB0aW9uTnVtYmVyJyxcbiAgICAnc2VydmljZUNvbnRyYWN0SWQnXG4gIF0sXG4gIHR5cGU6ICdvYmplY3QnLFxufVxuIl19